import { roundOffNumber, convertFeetToMetric, convertMetricToFeet } from '../../util';

function getMetersFromPixels(
	pixels: number,
	scale: number,
	metersPerPixel: number
) {
	return pixels * scale * metersPerPixel;
}

function pixelsToFeet(
	pixels: number,
	scale: number,
	metersPerPixel: number,
	precision = 0
) {
	const meters = getMetersFromPixels(pixels, scale, metersPerPixel);
	return roundOffNumber(convertMetricToFeet(meters), precision);
}

function getScaleFromFeet(
	feet: number,
	pixels: number,
	metersPerPixel: number,
	precision = 6
) {
	const meters = convertFeetToMetric(feet);
	const scale = meters / (pixels * metersPerPixel);
	return roundOffNumber(scale, precision);
}

export {
	getScaleFromFeet,
	pixelsToFeet,
	getMetersFromPixels
};